import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';

import { LoaderService } from 'src/app/common/loader/loader.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';

@Component({
	selector: 'app-transports-copy',
	templateUrl: './transports-copy.component.html',
	styleUrls: ['./transports-copy.component.css'],
})
export class TransportsCopyComponent implements OnInit {
	transport = {
		id: null,
		name: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly loader: LoaderService,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.loader.show();
		this.transport.id = this.route.snapshot.params.id;
		this.api.get('/bag/bagTransports/' + this.transport.id, (result, error) => {
			if (error) {
				return;
			}
			this.transport = result.data;
			this.loader.hide();
		});
	}

	copyAsk(type: string): void {
		this.question.ask('Czy rozumiesz na czym polega ta funkcja i chcesz kontynuować?', 'startAsk');
		const questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'startAsk') {
				return;
			}
			questionSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			this.copyStart(type);
		});
	}

	private copyStart(type: string): void {
		this.loader.show();
		this.api.put('/bag/bagTransportsCopier/' + this.transport.id, { type }, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			this.infobox.success('Skopiowano pomyślnie');
		});
	}
}
